'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/abs.js
// module id = yY1b
// module chunks = 0